import { Routes, Route, useNavigate } from "react-router-dom";

import { useState, useEffect } from 'react';
// import io from 'socket.io-client';
import { HTTPURL } from "../constants/matcher";
import Message from "../common/Message";
import ChatHome from "../pages/home/index";
import Chat from "../pages/chat";
// const socket = io.connect(HTTPURL);

// const CreateSocketRoutes = ({socket}) => {
const CreateSocketRoutes = (socket) => {
    const [username, setUsername] = useState('');
    const [room, setRoom] = useState('');

    return (
        <Route path="messages" >
            <Route path="" element={<Message />} />
            <Route
                path='join-room'
                element={
                    <ChatHome
                        username={username}
                        setUsername={setUsername}
                        room={room}
                        setRoom={setRoom}
                        socket={socket}
                    />
                }
            />
            <Route
                path='chat'
                element={
                    <Chat
                        username={username}
                        setUsername={setUsername}
                        room={room}
                        setRoom={setRoom}
                        socket={socket}
                    />
                }
            />
        </Route>
    );
};

export default CreateSocketRoutes;
